import { withFeatureFlags } from '@/flags.server';

import { fetchTradePageProps } from '@/components/pages/Trade/fetchTradePageProps.server';
import { TradePage, TradePageServerProps } from '@/components/pages/Trade/TradePage';

import { HOMEPAGE_REVAMP } from '@/utils/featureFlags';
import { routes } from '@/utils/routes';

const SwapPage = (props: TradePageServerProps) => <TradePage {...props} iFrameContext={false} />;

export default SwapPage;

export const getServerSideProps = withFeatureFlags(async (ctx, featureFlags) => {
  if (featureFlags[HOMEPAGE_REVAMP]) {
    return {
      redirect: {
        destination: ctx.resolvedUrl.replace(routes.SWAP, routes.INDEX),
        permanent: false,
      },
    };
  }

  const props = await fetchTradePageProps(ctx);
  ctx.res.setHeader('Cache-Control', 'public, s-maxage=10, stale-while-revalidate=59');

  return props;
});
